import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const ShopperAgentSandboxSenderSchema = createEnum([
  "customer",
  "ai",
  "internal",
]);
export type ShopperAgentSandboxSender = z.infer<
  typeof ShopperAgentSandboxSenderSchema
>;

export const ShopperAgentSandboxAttachmentSchema = z.object({
  url: z.string(),
  mimeType: z.string().nullish(),
});
export type ShopperAgentSandboxAttachment = z.infer<
  typeof ShopperAgentSandboxAttachmentSchema
>;

export const ShopperAgentSandboxKnowledgeSourceSchema = z.object({
  /** The corpus row's id — what the knowledge page opens, not the registry id. */
  id: z.string(),
  title: z.string(),
});
export type ShopperAgentSandboxKnowledgeSource = z.infer<
  typeof ShopperAgentSandboxKnowledgeSourceSchema
>;

export const ShopperAgentSandboxMessageSchema = z.object({
  sender: ShopperAgentSandboxSenderSchema,
  text: z.string(),
  attachments: z.array(ShopperAgentSandboxAttachmentSchema).optional(),
  knowledgeSources: z
    .array(ShopperAgentSandboxKnowledgeSourceSchema)
    .optional(),
});
export type ShopperAgentSandboxMessage = z.infer<
  typeof ShopperAgentSandboxMessageSchema
>;

/** Citations belong to the agent's turn, so a customer message carries none. */
export const ShopperAgentSandboxCustomerMessageSchema =
  ShopperAgentSandboxMessageSchema.omit({ knowledgeSources: true }).extend({
    sender: z.literal("customer"),
  });
export type ShopperAgentSandboxCustomerMessage = z.infer<
  typeof ShopperAgentSandboxCustomerMessageSchema
>;
